(() => {
  'use strict';
  const el = id => document.getElementById(id);
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 760px)');
  const menu = el('mobile-menu');
  const menuButton = document.querySelector('[data-open-menu]');
  if (menu && menuButton) {
    menuButton.addEventListener('click', () => {
      if (!menu.open) menu.showModal();
      menuButton.setAttribute('aria-expanded', 'true');
    });
    menu.addEventListener('close', () => menuButton.setAttribute('aria-expanded', 'false'));
    mobile.addEventListener('change', () => {
      if (!mobile.matches && menu.open) {
        menu.close();
        document.querySelector('.header .brand')?.focus();
      }
    });
  }
  document.querySelectorAll('[data-close-dialog]').forEach(button => {
    button.addEventListener('click', () => button.closest('dialog')?.close());
  });
  document.querySelectorAll('dialog').forEach(dialog => {
    dialog.addEventListener('click', event => {
      if (event.target.closest('a[href]')) dialog.close();
      if (event.target === dialog) {
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      }
    });
  });
  const tabs = el('collection-navigation');
  if (tabs) {
    const normalizePath = path => path.replace(/\/+$/, '') || '/';
    const currentPath = normalizePath(location.pathname);
    tabs.querySelectorAll('a[href]').forEach(link => {
      const active = normalizePath(new URL(link.href, location.href).pathname) === currentPath;
      link.classList.toggle('active', active);
      if (active) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  }
  if (tabs && mobile.matches) {
    const active = tabs.querySelector('[aria-current="page"]');
    if (active) tabs.scrollLeft = Math.max(0, active.offsetLeft - tabs.offsetLeft - 20);
  }

  const track = el('review-track');
  if (track) {
    const section = track.closest('.customer-reviews');
    const controls = section?.querySelector('.review-controls');
    const status = section?.querySelector('.review-position');
    const cards = [...track.children];
    const previous = controls?.querySelector('[data-review-direction="-1"]');
    const next = controls?.querySelector('[data-review-direction="1"]');
    if (cards.length && controls && previous && next) {
      const step = () => cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
      const update = () => {
        const width = step();
        if (!width) return;
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        const first = Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / width)));
        const visible = Math.max(1, Math.round(track.clientWidth / width));
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maximum - 2;
        controls.hidden = maximum < 2;
        if (status) {
          status.textContent = `Review ${first + 1}${visible > 1 ? '–' + Math.min(cards.length, first + visible) : ''} of ${cards.length}`;
          status.hidden = false;
        }
      };
      const move = direction => track.scrollBy({left: direction * step(), behavior: reduced.matches ? 'instant' : 'smooth'});
      controls.querySelectorAll('[data-review-direction]').forEach(button => button.addEventListener('click', () => move(Number(button.dataset.reviewDirection))));
      track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      let frame;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(update);
      }, {passive: true});
      if (window.ResizeObserver) new ResizeObserver(update).observe(track);
      else window.addEventListener('resize', update);
      update();
    }
  }

  const form = el('product-form');
  if (form) {
    const radios = [...form.querySelectorAll('input[name="id"]')];
    const quantity = el('product-qty');
    const minus = document.querySelector('[data-product-minus]');
    const plus = document.querySelector('[data-product-plus]');
    const submit = form.querySelector('[type="submit"]');
    const stickyAdd = document.querySelector('[data-sticky-add]');
    const originalLabel = submit?.textContent.trim() || 'Add to bag';
    const originalStickyLabel = stickyAdd?.textContent.trim() || 'Add to bag';
    const selected = () => radios.find(radio => radio.checked);
    const fromURL = new URLSearchParams(location.search).get('variant');
    if (fromURL && radios.some(radio => radio.value === fromURL)) radios.forEach(radio => radio.checked = radio.value === fromURL);
    function syncVariant(updateURL) {
      const variant = selected();
      if (!variant) return;
      const available = variant.dataset.available !== 'false';
      if (variant.dataset.price) document.querySelectorAll('[data-product-price], [data-sticky-price]').forEach(node => node.textContent = variant.dataset.price);
      const label = variant.dataset.label || variant.closest('label')?.querySelector('span')?.textContent.trim() || '';
      const selection = el('sticky-selection');
      if (selection && label) selection.textContent = [selection.dataset.finish, label].filter(Boolean).join(' · ');
      if (submit) {
        submit.disabled = !available;
        submit.textContent = available ? originalLabel : 'Sold out';
      }
      if (stickyAdd) {
        stickyAdd.disabled = !available;
        stickyAdd.textContent = available ? originalStickyLabel : 'Sold out';
      }
      if (updateURL) {
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.value);
        history.replaceState(null, '', url.pathname + url.search + url.hash);
      }
    }
    radios.forEach(radio => radio.addEventListener('change', () => syncVariant(true)));
    syncVariant(false);
    function syncQuantity() {
      if (!quantity) return;
      const minimum = Math.max(1, Number(quantity.min) || 1);
      const maximum = quantity.max ? Math.max(minimum, Number(quantity.max)) : Infinity;
      const value = Math.min(maximum, Math.max(minimum, Math.floor(Number(quantity.value) || minimum)));
      quantity.value = String(value);
      if (minus) minus.disabled = value <= minimum;
      if (plus) plus.disabled = value >= maximum;
    }
    minus?.addEventListener('click', () => { if (quantity) quantity.value = String(Number(quantity.value) - 1); syncQuantity(); });
    plus?.addEventListener('click', () => { if (quantity) quantity.value = String(Number(quantity.value) + 1); syncQuantity(); });
    quantity?.addEventListener('change', syncQuantity);
    syncQuantity();
    stickyAdd?.addEventListener('click', () => {
      syncQuantity();
      if (!submit?.disabled) form.requestSubmit(submit || undefined);
    });
    form.addEventListener('submit', syncQuantity);
    document.querySelector('[data-sticky-options]')?.addEventListener('click', () => {
      const options = form.querySelector('.size-field') || form.querySelector('.variant');
      options?.scrollIntoView({block: 'center', behavior: reduced.matches ? 'instant' : 'smooth'});
      options?.querySelector('input:checked, input, button, a')?.focus({preventScroll: true});
    });
  }
  const purchaseBar = document.querySelector('.mobile-purchase-bar');
  if (purchaseBar) {
    const measure = () => {
      const height = purchaseBar.getBoundingClientRect().height;
      if (height > 0) document.body.style.setProperty('--purchase-bar-height', height + 'px');
    };
    if (window.ResizeObserver) new ResizeObserver(measure).observe(purchaseBar);
    else window.addEventListener('resize', measure);
    measure();
  }

  const main = el('gallery-main-image');
  const thumbs = [...document.querySelectorAll('[data-gallery-index]')];
  const zoomButton = document.querySelector('[data-zoom-image]');
  if (main && zoomButton) {
    let active = Math.max(0, thumbs.findIndex(button => button.classList.contains('selected')));
    let currentFull = main.dataset.fullSrc || main.src;
    function showImage(index) {
      if (!Number.isInteger(index) || index < 0 || index >= thumbs.length) return;
      const button = thumbs[index];
      const image = button.querySelector('img');
      if (!image) return;
      active = index;
      currentFull = button.dataset.fullSrc || image.dataset.fullSrc || image.src;
      main.removeAttribute('srcset');
      main.src = currentFull;
      main.alt = image.alt;
      zoomButton.dataset.zoomImage = currentFull;
      const label = button.dataset.label || button.querySelector('span')?.textContent.trim() || `Image ${index + 1}`;
      if (el('gallery-image-note')) el('gallery-image-note').textContent = 'Tap to inspect';
      if (el('gallery-view-label')) el('gallery-view-label').textContent = label + (label.toLowerCase().includes('view') ? '' : ' view');
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('selected', i === index);
        thumb.setAttribute('aria-pressed', String(i === index));
      });
    }
    thumbs.forEach((button, index) => button.addEventListener('click', () => showImage(index)));
    let swipeStart = null;
    let suppressZoomUntil = 0;
    zoomButton.addEventListener('pointerdown', event => {
      if (event.pointerType === 'touch' && event.isPrimary) swipeStart = {x: event.clientX, y: event.clientY};
    });
    zoomButton.addEventListener('pointercancel', () => { swipeStart = null; });
    zoomButton.addEventListener('pointerup', event => {
      if (!swipeStart) return;
      const dx = event.clientX - swipeStart.x;
      const dy = event.clientY - swipeStart.y;
      swipeStart = null;
      if (thumbs.length > 1 && Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) {
        showImage((active + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length);
        suppressZoomUntil = Date.now() + 450;
      }
    });
    zoomButton.addEventListener('keydown', event => {
      if (thumbs.length > 1 && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
        event.preventDefault();
        showImage((active + (event.key === 'ArrowRight' ? 1 : -1) + thumbs.length) % thumbs.length);
      }
    });
    zoomButton.addEventListener('click', () => {
      const image = el('zoomed-image');
      const dialog = el('image-zoom');
      if (Date.now() < suppressZoomUntil || !image || !dialog) return;
      image.src = currentFull;
      image.alt = main.alt;
      if (!dialog.open) dialog.showModal();
    });
  }

  const grid = el('catalog-grid');
  const search = el('catalog-search');
  const sort = el('sort-products');
  if (grid) {
    const cards = [...grid.children];
    const originalOrder = new Map(cards.map((card, index) => [card, index]));
    const filter = () => {
      const terms = (search?.value || '').trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
      let count = 0;
      cards.forEach(card => {
        const words = (card.dataset.search || `${card.dataset.name || ''} ${card.textContent}`).toLocaleLowerCase();
        card.hidden = !terms.every(term => words.includes(term));
        if (!card.hidden) count++;
      });
      if (el('catalog-count')) el('catalog-count').textContent = count + (count === 1 ? ' finish' : ' finishes');
      if (el('catalog-empty')) el('catalog-empty').hidden = count > 0;
    };
    search?.addEventListener('input', filter);
    el('clear-search')?.addEventListener('click', () => {
      if (search) { search.value = ''; filter(); search.focus(); }
    });
    const rank = card => {
      const value = Number(card.dataset.rank);
      return card.dataset.rank && Number.isFinite(value) ? value : Infinity;
    };
    const featuredOrder = (a, b) => (rank(a) - rank(b)) || (originalOrder.get(a) - originalOrder.get(b));
    const orderCatalog = () => {
      const ordered = [...cards];
      ordered.sort((a, b) => sort?.value === 'price-low' ? Number(a.dataset.price) - Number(b.dataset.price) : sort?.value === 'price-high' ? Number(b.dataset.price) - Number(a.dataset.price) : sort?.value === 'name' ? (a.dataset.name || '').localeCompare(b.dataset.name || '') : featuredOrder(a, b));
      ordered.forEach(card => grid.append(card));
    };
    sort?.addEventListener('change', orderCatalog);
    orderCatalog();
  }
})();

// Preserve the approved film's playback, motion, data-saving, and visibility behavior.
(() => {
 const video=document.getElementById('hero-video');
 const button=document.getElementById('hero-motion');
 if(!video||!button)return;
 const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
 let visible=false,userChoice=null,failed=false;
 video.muted=true;
 video.defaultPlaybackRate=0.75;
 video.playbackRate=0.75;
 button.hidden=false;
 const label=()=>{
  const playing=!video.paused;
  button.classList.toggle('is-playing',playing);
  button.setAttribute('aria-label',playing?'Pause watch video':'Play watch video');
 };
 const sync=()=>{
  if(failed)return;
  const allowed=userChoice===true||(userChoice===null&&!motion.matches&&!navigator.connection?.saveData);
  if(!visible||document.hidden||!allowed){video.pause();return;}
  if(!video.getAttribute('src'))video.src=video.dataset.src;
  video.play()?.catch(()=>label());
 };
 video.addEventListener('playing',()=>{video.classList.add('has-video');label();});
 video.addEventListener('pause',label);
 video.addEventListener('error',()=>{failed=true;video.classList.remove('has-video');button.hidden=true;});
 button.addEventListener('click',()=>{userChoice=video.paused;sync();});
 motion.addEventListener('change',()=>{userChoice=null;sync();if(motion.matches)video.classList.remove('has-video');});
 document.addEventListener('visibilitychange',sync);
 if('IntersectionObserver' in window){
  const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:.1});
  observer.observe(video.parentElement);
 }else{visible=true;sync();}
})();
